import React from 'react'
import img1 from "../assest/images/banner-img/1.jpg";

import contactImg from "../assest/images/contact-us/cloud.webp";

function TourPackage_detalis() {
  return (
    <div>
      <>
        <div className="container-fulid">

        <div className="cloud-img">
          <div className="cloud-move">
            <img src={contactImg} alt="cloud" />

          </div>
        </div>
        <div className="page-banner page-banner1">
          <div className="main-title">
            <h3 className="breadcrumb-title">Tour Package Detalis</h3>
            <ul className="breadcrumb-menu">
              <li><a className="text-white" href="index.html">Home</a></li>
              <li>-</li>
              <li className="active">Tour Package Detalis </li>
            </ul>
          </div>
          
        </div>
      </div>

       <section className="home-destination pt-0">
        <div className="container">

          <div className="package-wrapper">
            <div className="package-card container">
              <div className="row align-items-center">

                {/* LEFT IMAGE */}
                <div className="col-lg-4">
                  <div className="package-img">
                    <img src={img1} alt="Leh Ladakh Tour" />
                  </div>
                </div>

                {/* RIGHT CONTENT */}
                <div className="col-lg-8">
                  <div className="package-content">

                    <h2>Leh Ladakh Adventure Tour 7 Nights / 8 Days</h2>

                    {/* Rating + Price */}
                    <div className="rating-price">
                      
                      <span className="price">₹28,999</span>
                    </div>

                    <p>
                      Experience the breathtaking beauty of Leh Ladakh with snow-covered
                      mountains, high altitude passes, peaceful monasteries, and thrilling
                      bike rides. Explore Pangong Lake, Nubra Valley, Magnetic Hill and
                      enjoy an unforgettable Himalayan adventure.
                    </p>

                    {/* Info Pills */}
                    <div className="info-pills">
                      <span>Available Seats : 18</span>
                      <span>Start Date : 15.06.2026</span>
                      <span>End Date : 22.06.2026</span>
                    </div>

                    {/* Location */}
                    <h4 className="location-title">Tour Highlights</h4>

                    <div className="features">
                      <span>✔ Leh – Nubra – Pangong Lake</span>
                      <span>✔ Khardung La Pass Ride</span>
                      <span>✔ Monastery & Local Sightseeing</span>
                    </div>

                    {/* Buttons */}
                    <div className="btn-group-custom">
                      <button className="btn-book">BOOK NOW</button>
                     
                    </div>

                  </div>
                </div>

              </div>
            </div>
          </div>

        </div>
      </section>
      </>
    </div>
  )
}

export default TourPackage_detalis
